import { Stack, TextField, PrimaryButton, ScrollablePane, Text, ICommandBarItemProps, IDropdownProps, ITextFieldProps, CommandBar, ITextField } from '@fluentui/react';
import * as React from 'react'
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { IQuestion } from '@piceasoft/core';
import { strings } from '../../../../../../../../../../localization/strings';
import { onRenderLabel } from '../../../../../../../../../renders/onRenderLabel';
import { SecondaryButton } from '../../../../../../../../buttons/SecondaryButton';
import { IStore, TransactionPlaceholders } from '../../../../../../../../../../core/store';
import { getCustomQuestionsPlaceholderItems } from '../../../../../../../../../../screens/services/Template/pivots/placeholdersSubMenuItems';
import { useSelector } from 'react-redux';
import { Experience } from '../../../../../../../helpers/evisibility';

type TProps = {
    onConfirm: (question: IQuestion) => void
    question: IQuestion
}

export const SequenceQuestionForm: React.FC<TProps> = ({ question, onConfirm }) => {
    const channel = useSelector(( s: IStore) => s.configurator.channel);
    const { control, handleSubmit, reset, formState: { errors }, getValues, setValue } = useForm<IQuestion>({ defaultValues: { ...question, } });
    const editorRef = React.useRef<ITextField>(null);

    const onSubmit: SubmitHandler<IQuestion> = data => {
        console.log(data)
        onConfirm({ ...data, index: question.index })
    };

    React.useEffect(() => {
        reset(question, { keepValues: false })
    }, [question])

    const pastePlaceholder = (placeholder: TransactionPlaceholders | string) => {
        if( editorRef.current !== null) {
            const txt = getValues().text
            const s = editorRef.current.selectionStart;
            let output = ""
            if( s) {
                output = txt.substring(0, s);
                output += placeholder;
                output += txt.substring( s);
            }
            else {
                output = txt;
                output += placeholder;
            }
            setValue( "text", output);
        }
    }

    const _items: ICommandBarItemProps[] = [
        {
            key: 'placeholders',
            text: strings.BUTTONS.TEXT.PLACEHOLDERS,
            iconProps: { iconName: 'Variable2' },
            subMenuProps: {
                items: getCustomQuestionsPlaceholderItems(pastePlaceholder)
            }
        },
    ]
  
    const onRenderQuestionBodyLabel = (props: ITextFieldProps | IDropdownProps | undefined): JSX.Element => {
        const label = onRenderLabel(props);
        if( channel !== Experience.Retail) {
            return label;
        }
    
        return <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 18, padding: "0 0 4px 0" }}>
            {label}
            <Stack.Item grow>
                <CommandBar
                    items={_items}
                    styles={{ root: { margin: 0, padding: 0 } }}
                    overflowButtonProps={{ ariaLabel: 'More commands' }}
                    ariaLabel="Inbox actions"
                    primaryGroupAriaLabel="Main actions"
                    farItemsGroupAriaLabel="More actions"
                />
            </Stack.Item>
        </Stack>
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} style={{ display: "flex", flexDirection: "column", flexWrap: "nowrap", height: "100%", boxSizing: "border-box" }}>
            <Stack verticalFill>
                <Stack.Item verticalFill style={{ position: "relative" }}>
                    <ScrollablePane>
                        <Stack tokens={{ padding: 20, childrenGap: 16 }}>
                            <Stack.Item>
                                <Stack horizontal grow>
                                    <Stack horizontal grow horizontalAlign="end" tokens={{ childrenGap: 8 }}>
                                        <SecondaryButton iconProps={{ iconName: "Undo" }} onClick={() => reset(question)} />
                                        <PrimaryButton onClick={handleSubmit(onSubmit)}>{strings.BUTTONS.TEXT.CONFIRM}</PrimaryButton>
                                    </Stack>
                                </Stack>
                            </Stack.Item>
                            <Stack grow tokens={{ childrenGap: 16 }}>
                                <Controller
                                    control={control}
                                    name="title"
                                    rules={{ 
                                        validate: (value) => value.trim().length > 0 ? true : strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.TITLE.REQUIRED, 
                                        required: strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.TITLE.REQUIRED 
                                    }}
                                    render={({ field }) =>
                                        <TextField {...field}
                                            required
                                            onRenderLabel={onRenderLabel}
                                            label={strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.TITLE.LABEL}
                                            title={strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.TITLE.TITLE}
                                            placeholder={strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.TITLE.PLACEHOLDER}
                                            errorMessage={errors.title?.message}
                                        />
                                    }
                                />
                                <Controller
                                    name="text"
                                    control={control}
                                    render={({ field }) =>
                                        <TextField {...field}
                                            componentRef={editorRef}
                                            multiline
                                            resizable={false}
                                            style={{ height: 100 }}
                                            onRenderLabel={onRenderQuestionBodyLabel}
                                            label={strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.TEXT.LABEL}
                                            title={strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.TEXT.TITLE}
                                            placeholder={strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.TEXT.PLACEHOLDER}
                                            errorMessage={errors.text?.message}
                                        />
                                    }
                                />
                                <Controller
                                    name="warning"
                                    control={control}
                                    render={({ field }) =>
                                        <TextField {...field}
                                            multiline
                                            resizable={false}
                                            style={{ height: 100 }}
                                            onRenderLabel={onRenderLabel}
                                            label={strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.WARNING.LABEL}
                                            title={strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.WARNING.TITLE}
                                            placeholder={strings.CONSTRUCTOR.INSPECTIONS.INTERVIEW.QUESTIONS_CONFIGURATOR.FORM.QUESTION.WARNING.PLACEHOLDER}
                                            errorMessage={errors.warning?.message}
                                        />
                                    }
                                />
                            </Stack>
                        </Stack>
                    </ScrollablePane>
                </Stack.Item>
            </Stack>
        </form>
    )
}
